__turbopack_context__.v({
  "content": "BlockPairingWheel-module-scss-module__4GGg1G__content",
  "fade-in": "BlockPairingWheel-module-scss-module__4GGg1G__fade-in",
  "image": "BlockPairingWheel-module-scss-module__4GGg1G__image",
  "imageContainer": "BlockPairingWheel-module-scss-module__4GGg1G__imageContainer",
  "inner": "BlockPairingWheel-module-scss-module__4GGg1G__inner",
  "inset": "BlockPairingWheel-module-scss-module__4GGg1G__inset",
  "isLoading": "BlockPairingWheel-module-scss-module__4GGg1G__isLoading",
  "isReady": "BlockPairingWheel-module-scss-module__4GGg1G__isReady",
  "loading": "BlockPairingWheel-module-scss-module__4GGg1G__loading",
  "root": "BlockPairingWheel-module-scss-module__4GGg1G__root",
  "wheel": "BlockPairingWheel-module-scss-module__4GGg1G__wheel",
  "wheelClapper": "BlockPairingWheel-module-scss-module__4GGg1G__wheelClapper",
  "wheelClapperContainer": "BlockPairingWheel-module-scss-module__4GGg1G__wheelClapperContainer",
  "wheelRotate": "BlockPairingWheel-module-scss-module__4GGg1G__wheelRotate",
  "wheelSize": "BlockPairingWheel-module-scss-module__4GGg1G__wheelSize",
});
